import TabsWrapper from "./TabsWrapper";

export default TabsWrapper;
